import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import * as userActions from 'lib/store/user'
import * as appActions from 'lib/store/app'
import StoredData from './StoredData'

export class StoredDataContainer extends React.Component {
  static propTypes = {
    fetchUserProfile: PropTypes.func.isRequired,
    setLoading: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired
  }

  componentDidMount() {
    document.title = 'Your Data'

    this.props.fetchUserProfile().then(() => {
      this.props.setLoading(false)
    })
  }

  render() {
    const { profile, isLoading } = this.props
    if (isLoading) return null

    return (
      <StoredData {...profile} />
    )
  }
}

const mapStateToProps = state => ({
  isLoading: state.app.isLoading,
  profile: state.user.profile
})

const mapDispatchToProps = dispatch => ({
  setLoading: loadingState => dispatch(appActions.setLoading(loadingState)),
  fetchUserProfile: () => dispatch(userActions.fetchUserProfile())
})

export default connect(mapStateToProps, mapDispatchToProps, undefined, {
  pure: false
})(StoredDataContainer)



// WEBPACK FOOTER //
// ./src/components/profile/StoredDataContainer.js